/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from '../../../client.ts';
import type { RequestConfig, ResponseErrorConfig } from '../../../client.ts';
import type { SitemapControllerGetSitemapQueryResponse } from '../../types/SitemapControllerGetSitemap.ts';
import type { QueryKey, QueryClient, QueryObserverOptions, UseQueryResult } from '@tanstack/react-query';
import { sitemapGetSitemap } from '../../methods/sitemapGetSitemap.ts';
import { queryOptions, useQuery } from '@tanstack/react-query';

export const sitemapGetSitemapQueryKey = () => [{ url: '/api/sitemap' }] as const;

export type SitemapGetSitemapQueryKey = ReturnType<typeof sitemapGetSitemapQueryKey>;

export function sitemapGetSitemapQueryOptions(config: Partial<RequestConfig> & { client?: typeof fetch } = {}) {
  const queryKey = sitemapGetSitemapQueryKey();
  return queryOptions<
    SitemapControllerGetSitemapQueryResponse,
    ResponseErrorConfig<Error>,
    SitemapControllerGetSitemapQueryResponse,
    typeof queryKey
  >({
    queryKey,
    queryFn: async ({ signal }) => {
      config.signal = signal;
      return sitemapGetSitemap(config);
    },
  });
}

/**
 * {@link /api/sitemap}
 */
export function useSitemapGetSitemap<
  TData = SitemapControllerGetSitemapQueryResponse,
  TQueryData = SitemapControllerGetSitemapQueryResponse,
  TQueryKey extends QueryKey = SitemapGetSitemapQueryKey,
>(
  options: {
    query?: Partial<
      QueryObserverOptions<
        SitemapControllerGetSitemapQueryResponse,
        ResponseErrorConfig<Error>,
        TData,
        TQueryData,
        TQueryKey
      >
    > & { client?: QueryClient };
    client?: Partial<RequestConfig> & { client?: typeof fetch };
  } = {},
) {
  const { query: queryConfig = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...queryOptions } = queryConfig;
  const queryKey = queryOptions?.queryKey ?? sitemapGetSitemapQueryKey();

  const query = useQuery(
    {
      ...sitemapGetSitemapQueryOptions(config),
      queryKey,
      ...queryOptions,
    } as unknown as QueryObserverOptions,
    queryClient,
  ) as UseQueryResult<TData, ResponseErrorConfig<Error>> & { queryKey: TQueryKey };

  query.queryKey = queryKey as TQueryKey;

  return query;
}
